import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import NavButtons from 'components/Motion_Detection/NavButtons';
import PrimaryBox from 'components/Motion_Detection/Passive_Infrared_Detection/PrimaryBox';
import ForumBox from 'components/Motion_Detection/FTP_Server_Setup/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  NavButtons,
  PrimaryBox,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};